<div class="md-drppicker" [ngClass]="{
    ltr: locale.direction === 'ltr',
    rtl: this.locale.direction === 'rtl',
    'disabled-clock': this.disabled==true
}" >
  <div class="calendar-time" >
    <div class="select">
      <select class="hourselect select-item" [disabled]="disabled"
        [(ngModel)]="timepickerVariables.selectedHour"
        (ngModelChange)="timeChanged($event)">
        @for (i of timepickerVariables.hours; track i) {
          <option [value]="i"
          [disabled]="timepickerVariables.disabledHours.indexOf(i) > -1">{{i}}</option>
        }
      </select>
    </div>
    <div class="select">
      <select class="select-item minuteselect" [disabled]="disabled"
        [(ngModel)]="timepickerVariables.selectedMinute"
        (ngModelChange)="timeChanged($event)">
        @for (i of timepickerVariables.minutes; track i; let index = $index) {
          <option [value]="i"
            [disabled]="timepickerVariables.disabledMinutes.indexOf(i) > -1">
          {{timepickerVariables.minutesLabel[index]}}</option>
        }
      </select>
      <span class="select-highlight"></span>
      <span class="select-bar"></span>
    </div>
    <div class="select">
      @if (timePickerSeconds) {
        <select class="select-item secondselect" [disabled]="disabled"
          [(ngModel)]="timepickerVariables.selectedSecond"
          (ngModelChange)="timeChanged($event)">
          @for (i of timepickerVariables.seconds; track i; let index = $index) {
            <option [value]="i"
              [disabled]="timepickerVariables.disabledSeconds.indexOf(i) > -1">
            {{timepickerVariables.secondsLabel[index]}}</option>
          }
        </select>
      }
      <span class="select-highlight"></span>
      <span class="select-bar"></span>
    </div>
    <div class="select">
      @if (!timePicker24Hour) {
        <select class="select-item ampmselect" [disabled]="disabled"
          [(ngModel)]="timepickerVariables.ampmModel" (ngModelChange)="timeChanged($event)">
          <option value="AM" [disabled]="timepickerVariables.amDisabled">AM</option>
          <option value="PM" [disabled]="timepickerVariables.pmDisabled">PM</option>
        </select>
      }
      <span class="select-highlight"></span>
      <span class="select-bar"></span>
    </div>
    <div class="select">
      <div class="clock-icon">
        <img src="assets/images/icon-clock.svg" />
      </div>
    </div>
  </div>
</div>